import { gql } from '@apollo/client';

export const SET_SECONDARY_LOCATION = gql`
mutation setSecondaryLocation($input: SetSecondaryLocationInput!) {
  setSecondaryLocation(input: $input) {
    errors
    clientMutationId
    officerIncidentSpecific {
      id
      secondaryAddress
    }
  }
}
`